import EquipmentTableHelper from "./equipment-table-helper";
import EquipmentsGridHelper from "./equipment-grid-helper";

const EquipmentHelpers = {
  TableMain: EquipmentTableHelper,
  GridMain: EquipmentsGridHelper,
};

export default EquipmentHelpers;
